export default "__VITE_ASSET__BOO4LcLj__"